/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ seats: NonNullable<unknown>, members: NonNullable<unknown> }} Partner_Org_Seats_Explainer_CappedInputs */



/**
* | output |
* | --- |
* | "Billed for {seats} seats — the plan's maximum. {members} members today." |
*
* @param {Partner_Org_Seats_Explainer_CappedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_seats_explainer_capped = /** @type {((inputs: Partner_Org_Seats_Explainer_CappedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Seats_Explainer_CappedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Abgerechnet werden ${i?.seats} Plätze — das Maximum des Tarifs. Heute: ${i?.members} Mitglieder.`)
	return /** @type {LocalizedString} */ (`Billed for ${i?.seats} seats — the plan's maximum. ${i?.members} members today.`)
});